import React, { createContext, useEffect, useContext } from 'react'

import { useToggle } from '../../hooks'
import { toggleBodyClass } from './utils'

const HeaderContext = createContext()
const useHeaderContext = () => useContext(HeaderContext)

const HeaderConsumer = HeaderContext.Consumer

const HeaderProvider = ({
  children,
  lightMode,
  enableTracking,
  pageOrScreen,
  hasSubNav,
  isMinimal,
}) => {
  const { isOpen, toggle } = useToggle()
  const state = {
    isOpen,
    toggle,
    lightMode,
    enableTracking,
    pageOrScreen,
    hasSubNav,
    isMinimal,
  }

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('keydown', onKeyDown)
    }

    return () => {
      document.removeEventListener('keydown', onKeyDown)
    }
  }, [isOpen])

  const onKeyDown = ({ key }) => {
    if (key === 'Escape') {
      toggle()
      toggleBodyClass()
    }
  }

  return (
    <HeaderContext.Provider value={state}>{children}</HeaderContext.Provider>
  )
}

export { HeaderConsumer, HeaderProvider, useHeaderContext }
